/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import authMgr from '@ion/applications/src/authentication/AuthenticationManager';
import {loggedInUserSelector} from '@ion/applications/src/store/selectors/login';
import {signoutCTC, signoutSSO} from '@/store/actions/login';

/**
 * @useLogout
 *
 * Provides a reusable hook which allows for automating the process of logout from app.
 *
 * ```typescript
 *
 *   import {useLogout} from 'hooks';
 *
 *   const onLogout = useLogout();
 *
 * ```
 *
 */
export const useLogout = () => {
  const dispatch = useDispatch();
  const user     = useSelector(loggedInUserSelector);

  const onLogout = useCallback(function() {
    if (authMgr.getIsOIDCEnabled()) {
      dispatch(signoutSSO(user?.username, authMgr.hasIdProvider) as any);
    } else {
      dispatch(signoutCTC() as any);
    }
  }, []);
  return onLogout;
};
